import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { RtUICoreOverlayModule } from '../core/overlay/overlay.module';
import { DropdownItem, DropdownScrollableComponent } from './dropdown-scrollable.component';

@NgModule({
  imports: [CommonModule, RtUICoreOverlayModule, DropdownScrollableComponent],
  exports: [DropdownScrollableComponent],
})
export class RtDropdownScrollableModule {}
export { DropdownItem, DropdownScrollableComponent };
